import contactDataForCountries from "nvent-web/utils/contactDataForCountries";

export const getEmailByCountryCode = (userCountryCode: string) => {
  const contactData = contactDataForCountries.find(
    ({ countryCode }) => countryCode === userCountryCode
  );

  return contactData ? contactData.mail : "";
};
